import React from 'react'
import {Box, Typography, Grid, Link, Divider} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import unisysLogoText from 'assets/images/UnisysFooterLogo.svg'
import {cpsUrl} from 'config/base'
import './index.scss'
import moment from 'moment'
import {EXTERNAL_LINKS} from 'config/path'

const Footer = () => {
    const theme = useTheme()
    const aboveSm = useMediaQuery(theme.breakpoints.up('sm'))
    const currentYear = moment().format('YYYY')

    return (
        <Box className='footerContainer centered'>
            <Grid container className='itemsContainer' rowGap={3}>
                <Grid
                    item
                    xs={12}
                    sm={3}
                    flex={1}
                    className='logoContainer'
                    justifyContent={aboveSm ? 'flex-start' : 'center'}
                >
                    <Box className='logoText'>
                        <a
                            href={'https://www.unisys.com/solutions/industries/#travelAndTransportation'}
                            target='_blank'
                            rel='noreferrer'
                        >
                            <img src={unisysLogoText} alt='Logo second' />
                        </a>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={9}>
                    <Grid
                        container
                        direction='row'
                        justifyContent={aboveSm ? 'flex-end' : 'space-around'}
                        alignItems='center'
                        columnGap={aboveSm ? 2 : 0}
                        rowGap={2}
                        className='linkContainer'
                    >
                        <Link href={`${cpsUrl}/lmsweb/aboutcps.jsp`} color='inherit' target='_blank' rel='noreferrer'>
                            About CPS
                        </Link>
                        |
                        <Link href={EXTERNAL_LINKS.terms} color='inherit' target='_blank' rel='noreferrer'>
                            Terms of Use
                        </Link>
                        |
                        <Link
                            href='https://www.unisys.com/unisys-legal/privacy/'
                            color='inherit'
                            target='_blank'
                            rel='noreferrer'
                        >
                            Privacy
                        </Link>
                        |
                        <Link
                            href='https://www.linkedin.com/company/cargo-portal-services/'
                            color='inherit'
                            target='_blank'
                            rel='noreferrer'
                        >
                            LinkedIn
                        </Link>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Divider className='customDivider' />
                </Grid>
                <Grid item xs={12}>
                    <Typography align='center' className='copyright'>
                        <span>&copy;</span>
                        <span> {currentYear} Unisys Corporation. All Rights Reserved.</span>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer
